const WIZARD_CODES = {
  ONBOARDING: 'onboarding'
};

export default WIZARD_CODES;
